module.exports = __webpack_public_path__ + "media/images/front/icon_05_arrow_y-b460ba48716b9415887326e4d76f9bc3.png";